import React from 'react';
import PropTypes from 'prop-types';

export const IconVip = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons / categories / VIP">
      <path className="icon-filled-path" d="M2.91473 6.72051L3.98678 15.833H16.0227L17.0947 6.72051L13.7532 8.9482L10.0047 3.7004L6.25627 8.9482L2.91473 6.72051ZM2.33863 4.33336L5.83803 6.66629L9.32657 1.78232C9.59407 1.40781 10.1146 1.32107 10.4891 1.58858C10.5639 1.64203 10.6293 1.70749 10.6828 1.78232L14.1714 6.66629L17.6707 4.33336C18.0537 4.07807 18.5711 4.18154 18.8264 4.56449C18.9362 4.72917 18.9837 4.92754 18.9607 5.1241L17.5913 16.7637C17.5419 17.1834 17.1862 17.4996 16.7637 17.4996H3.24574C2.82317 17.4996 2.46749 17.1834 2.41812 16.7637L1.04876 5.1241C0.994982 4.66702 1.32193 4.25289 1.77902 4.19911C1.97558 4.17599 2.17396 4.22358 2.33863 4.33336Z" fill="white" />
    </g>
  </svg>
);

IconVip.propTypes = {
  className: PropTypes.string
};

IconVip.defaultProps = {
  className: ''
};
